.dw{aspect-ratio:1/1;}